import { forwardRef } from "react";

import { Box } from "@mui/material";

import type { BoxProps } from "@mui/material";

interface Props {
  children: React.ReactNode;
  title?: React.ReactNode;
  sx?: BoxProps;
}

export const DashboardItemLayout = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { children, sx = {}, title = null } = props;

    return (
      <Box
        ref={ref}
        boxShadow={1}
        borderRadius={4}
        sx={{
          height: "fit-content",
          background: "white",
          ...sx,
        }}
      >
        {title}
        {children}
      </Box>
    );
  },
);
